module.exports = __webpack_public_path__ + "img/wetwall-logo-trimmed.4e3ef21f.png";